import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import { FlexContainer } from 'common/styles';
import AbvSearchIcon from 'assets/icons/abvSearchIcon.svg';
import CloseIcon from 'assets/icons/customizable-close-button.svg'

export const SearchBarContainer = styled(FlexContainer)`
  background: #ffffff;
  border-bottom: ${p => (p.border ? p.border : '1px solid #e0e0e0')};
  padding: 7px 8px;
  margin: ${p => (p.margin ? p.margin : 0)};
  & > svg {
    margin-right: 12px;
  }
`;

const Input = styled.input`
  width: 100%;
  color: #283446;
  font-size: 12px;
  line-height: 14px;
  font-weight: normal;
  border: none;
  outline: none;
  padding: 0;
  &::placeholder {
    color: #959595;
    font-size: 12px;
    font-weight: normal;
  }
  &:hover {
    border: none;
  }
  &:focus {
    border: none;
  }
`;

const SearchBar = ({ testId, placeholder, margin, showIcon, border, borderRadius, onChange }) => {

    return (
        <SearchBarContainer margin={margin} border={border} borderRadius={borderRadius}>
            {showIcon && <img src={AbvSearchIcon} style={{marginRight: "8px"}}/>}
            <Input
                data-testid={testId}
                type="text"
                placeholder={placeholder}
                onChange={e => {
                    /* e.persist() - used to persist event when event is used callback func.
                      Read more - Read more https://reactjs.org/docs/legacy-event-pooling.html
                    */
                    e.persist();
                    onChange(e);
                }}
            />
        </SearchBarContainer>
    )
};


export default SearchBar;
